import React, { useState, useEffect } from 'react';
import '../pages/AdminDashboard.css'; 

const VistaPedidos = () => {
  const [pedidos, setPedidos] = useState([]);
  const [cargando, setCargando] = useState(true);
  
  // NUEVO ESTADO PARA EL MODAL
  const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);

  useEffect(() => {
    const fetchPedidos = async () => {
      try {
        const respuesta = await fetch('https://api.pascolo.com.ar/api/pedidos');
        const data = await respuesta.json();
        setPedidos(data);
      } catch (error) {
        console.error("Error al cargar los pedidos:", error);
      } finally {
        setCargando(false);
      }
    };

    fetchPedidos();
  }, []);

  const formatearFecha = (fechaString) => {
    const opciones = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(fechaString).toLocaleDateString('es-AR', opciones);
  };

  const formatearPrecio = (precio) => {
    if (!precio) return '$0';
    return `$ ${Number(precio).toLocaleString('es-AR')}`;
  };

  if (cargando) return <p>Cargando pedidos...</p>;

  return (
    <div className="vista-pedidos">
      <h2>Listado de Pedidos</h2>
      
      <div className="tabla-container" style={{ overflowX: 'auto', backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
          <thead>
            <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #ddd' }}>
              <th style={{ padding: '15px' }}>ID</th>
              <th style={{ padding: '15px' }}>Fecha</th>
              <th style={{ padding: '15px' }}>Cliente</th>
              <th style={{ padding: '15px' }}>Detalle</th>
              <th style={{ padding: '15px' }}>Total</th>
              <th style={{ padding: '15px' }}>Estado</th>
            </tr>
          </thead>
          <tbody>
            {pedidos.map((pedido) => (
              <tr key={pedido.id} style={{ borderBottom: '1px solid #eee' }}>
                <td style={{ padding: '15px', fontWeight: 'bold' }}>#{pedido.id}</td>
                <td style={{ padding: '15px', fontSize: '14px', color: '#555' }}>
                  {formatearFecha(pedido.fecha_creacion)}
                </td>
                
                {/* --- COLUMNA CLIENTE CON BOTÓN MODAL --- */}
                <td style={{ padding: '15px' }}>
                  <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{pedido.cliente_nombre}</div>
                  <button 
                    onClick={() => setPedidoSeleccionado(pedido)}
                    style={{ background: '#009ee3', color: 'white', border: 'none', padding: '4px 8px', borderRadius: '4px', fontSize: '12px', cursor: 'pointer' }}
                  >
                    Ver Info
                  </button>
                </td>

                <td style={{ padding: '15px', fontSize: '13px' }}>
                  <ul style={{ margin: 0, paddingLeft: '15px' }}>
                    {pedido.items.map((item, index) => (
                      <li key={index}>
                        {item.cant}x {item.prod} ({item.formato})
                      </li>
                    ))}
                  </ul>
                </td>
                <td style={{ padding: '15px', fontWeight: 'bold', color: '#2d5a27' }}>
                  {formatearPrecio(pedido.monto_total)}
                </td>
                <td style={{ padding: '15px' }}>
                  <span style={{
                    padding: '6px 12px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    backgroundColor: pedido.estado === 'pendiente' ? '#fff3cd' : '#d4edda',
                    color: pedido.estado === 'pendiente' ? '#856404' : '#155724'
                  }}>
                    {pedido.estado}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* --- TARJETA MODAL FLOTANTE --- */}
      {pedidoSeleccionado && (
        <div 
          className="modal-overlay" 
          onClick={() => setPedidoSeleccionado(null)} // Cierra al tocar el fondo
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
        >
          <div 
            className="modal-card" 
            onClick={(e) => e.stopPropagation()} // Evita que se cierre al tocar la tarjeta
            style={{
              backgroundColor: 'white',
              padding: '30px',
              borderRadius: '10px',
              width: '400px',
              maxWidth: '90%',
              boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
            }}
          >
            <h3 style={{ marginTop: 0, borderBottom: '2px solid #2d5a27', paddingBottom: '10px', color: '#333' }}>
              Datos del Cliente
            </h3>
            
            <div style={{ marginTop: '20px', fontSize: '15px', lineHeight: '1.8' }}>
              <p style={{ margin: '8px 0' }}><strong>Nombre:</strong> {pedidoSeleccionado.cliente_nombre}</p>
              <p style={{ margin: '8px 0' }}>
                <strong>WhatsApp:</strong> {' '}
                <a 
                  href={`https://wa.me/${pedidoSeleccionado.cliente_whatsapp}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: '#009ee3', textDecoration: 'none' }}
                >
                  {pedidoSeleccionado.cliente_whatsapp || 'No registrado'}
                </a>
              </p>
              <p style={{ margin: '8px 0' }}><strong>DNI:</strong> {pedidoSeleccionado.dni || 'No registrado'}</p>
              <p style={{ margin: '8px 0' }}><strong>CUIT:</strong> {pedidoSeleccionado.cuit_cuil || 'No registrado'}</p>
              <p style={{ margin: '8px 0' }}><strong>Dirección:</strong> {pedidoSeleccionado.cliente_direccion || 'Retira por sucursal'}</p>
            </div>

            <button 
              onClick={() => setPedidoSeleccionado(null)}
              style={{
                marginTop: '25px',
                width: '100%',
                padding: '12px',
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontWeight: 'bold',
                fontSize: '15px'
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default VistaPedidos;